const root = document.documentElement;
const stickyHeader = document.querySelector('#header');

function setStickyHeaderHeight() {
	if ( !stickyHeader ) {
		root.style.setProperty('--sticky-header-height', '0px');
		return;
	}
	if ( Foundation.MediaQuery.atLeast('large') ) {
		root.style.setProperty('--sticky-header-height', stickyHeader.offsetHeight + "px");
	} else {
		root.style.setProperty('--sticky-header-height', '0px');
	}
}

function mainNavToggle() {
	const toggle = document.querySelector('.main-nav-toggle');
	if ( !toggle ) return;

	toggle.addEventListener('click', function(e) {
	  document.querySelector('body')
	  	.classList.toggle('is-nav-open');
	});
}

function flexWrapper() {
	document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com')
		.forEach((el) => {
			const classes = ['flex-video'];
			if ( el.width / el.height > 1.5 ) {
				classes.push('widescreen');
			}

			const wrapper = document.createElement('div');
			wrapper.classList.add(...classes);

			// insert wrapper before el
			el.parentNode.insertBefore(wrapper, el);

			// move el into wrapper
			wrapper.appendChild(el);
		});
}

const initLayout = () => {
	setStickyHeaderHeight();
	mainNavToggle();
	flexWrapper();
}

document.addEventListener("DOMContentLoaded", initLayout);

if ( stickyHeader ) {
	window.addEventListener('resize', setStickyHeaderHeight);
	window.addEventListener("load", setStickyHeaderHeight);
}